import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Renderer from './views/Renderer.vue'


Vue.use(Router)
export default new Router({
  mode: 'history',
  base: '/commissions/european-motorways-1920-2020/',
  routes: [

    {
      path: '/renderer',
      name: 'renderer',
      component: Renderer,
      props: { debug: false}
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      props: { debug: false}
    },
    {
      path: '/:year',
      name: 'fact',
      component: Home,
      props: { debug: false}
    },
    {
      path: '/gui',
      name: 'gui',
      component: Home,
      props: { debug: true}
    },
    {
      path: '/facts',
      name: 'facts',
      component: Home
    },

  ]
})
